import script from "./goRinSyo0078.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0078.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0078.vue?vue&type=style&index=0&id=3ffe540a&lang=scss"

const __exports__ = script;

export default __exports__